const IconAngleLeft = (props) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M5.40039 7.97182L9.62017 12.5433L10.2944 11.9209L6.64915 7.97182L10.2944 4.02277L9.62017 3.40039L5.40039 7.97182Z'
        fill='currentColor'
      />
    </svg>
  )
}

export default IconAngleLeft
